<div class="sort-by-wrapper">
  <p class="sort-by-text" (click)="open()">
    Sort by
    <img class="sort-by-icon" src="../../../../assets/icons/sort-icon.png" />
  </p>

  <div class="sort-by-modal" *ngIf="showModal">
    <ng-container *ngFor="let sortOption of sortOptions">
      <p
        [class.deselected]="this.selectedSortCategory !== sortOption.type"
        (click)="sortBy(sortOption.type)"
      >
        {{ sortOption.label }}
      </p>
    </ng-container>
    <!-- Close modal button -->
    <img
      class="close-button"
      src="/assets/icons/close-btn-white.svg"
      (click)="close()"
    />
  </div>
</div>
<div *ngIf="showModal" class="backdrop"></div>
